export default "__VITE_ASSET__BYv0MyCB__"